import { useTranslate } from '@repo/shared/hooks'
import { FormSchema, useAppForm } from '@repo/ui/hooks'

import { useLoginSchema } from '../../schemas'
import { usePhoneOtp } from '@repo/services'
import { handleNumericInput, handlePasteInput } from '@repo/tools'
import {
  Button,
  Form,
  FormField,
  FormItemWrapper,
  Input,
} from '@repo/ui/components'
import { IMobileKycFormProps } from './mobile-kyc.types'
import { normalizeMobile } from '@repo/ui/lib'
import { useErrorHandler } from '@repo/shared/hooks'

export const MobileKycForm = (props: IMobileKycFormProps) => {
  const { onSuccess } = props
  const { t } = useTranslate()
  const { mobileSchema } = useLoginSchema()
  const { errorHandler } = useErrorHandler()
  const { form } = useAppForm({
    formSchema: mobileSchema,
  })
  const phoneOtpMutation = usePhoneOtp()

  const onSubmit = (data: FormSchema<typeof mobileSchema>) => {
    phoneOtpMutation.mutate(
      { phone: normalizeMobile(data.mobile) },
      {
        onSuccess: (res) => onSuccess(data.mobile, res?.data?.otp ?? 0),
        onError: errorHandler,
      },
    )
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className='space-y-3xl w-full'
      >
        <FormField
          control={form.control}
          name='mobile'
          render={({ field }) => (
            <FormItemWrapper
              title={t('common_mobileNumber')}
              caption={t('loginPage_mobileStartsWithZero')}
              inputSize='lg'
            >
              <Input
                autoComplete='off'
                type='text'
                className='ltr'
                inputSize='lg'
                variant={'fill'}
                {...field}
                onKeyDown={(e) => handleNumericInput(e, 11)}
                onPaste={(e) => handlePasteInput(e, 11)}
              />
            </FormItemWrapper>
          )}
        />
        <Button
          className='w-full'
          type='submit'
          variant='fill'
          size='lg'
          loading={phoneOtpMutation.isPending}
        >
          {t('common_continue')}
        </Button>
      </form>
    </Form>
  )
}
